<template>
  <div class="rb-affirm-updater" v-if="affirmHtml">
    <div v-html="affirmHtml"></div>
    <a
      class="affirm-modal-trigger"
      aria-label="Prequalify now about Affirm Financing (opens in modal)"
      @click.prevent="notifyPrequalify"
      href="#"
      >Prequalify now</a
    >
  </div>
</template>
<script>
/**
 * Component receives HTML from main PDP and updates markup to leverage Affirm library behavior
 */
import CommMixin from "@/mixins/CommMixin";
export default {
  mixins: [CommMixin],
  data: function () {
    return {
      affirmHtml: "",
    };
  },
  beforeMount: function () {
    this.subscribe("rb-update-installments", this.onUpdateInstallments);
  },
  methods: {
    onUpdateInstallments: function (dataInstallments) {
      this.affirmHtml = dataInstallments.html;
    },
    notifyPrequalify: function () {
      this.broadcast("rb-prequalify-now");
    },
  },
};
</script>
